import React from 'react';

//CSS File
import './pricingplans.css';

const PricingPlans = () => {

    return (

        <section className='pricing-plans'>

            <div className='pricing-plans-content'>

                <h1>Pricing  <span>Plans</span> </h1>
                <p>Join our exclusive beta program to experience AssistAI for free.</p>

            </div>

        </section>

    )

}

export default PricingPlans;